module.exports = __webpack_public_path__ + "static/media/Emotes-Thick.edad3057.png";